<ion-modal [isOpen]="isOpen"
backdropDismiss="true"
[cssClass]="'scorm-modal-player' + ionClass"
(didDismiss)="didDismissModal()"
>
  <ng-template>
    <div class="base-modal-shadow bg-white m-auto relative"
    [ngClass]=" customStyle ? customStyle : 'w-full h-full'"
    [ngStyle]="{'border-radius': displayHeader ? '6px' : '0px'}"
    >
      <div class="px-2 py-[6px] md:py-2 md:px-3 text-white grid grid-cols-[1fr_auto] items-center gap-4 bg-primary">
        <span class="overflow-text-cover-1 text-sm">{{modalTitle}}</span>
        <div class="flex items-center gap-4">
          <button *ngIf="displayFooter" (click)="onFullscreen(true)" class="flex justify-center items-center bg-transparent p-[2px]">
            <mat-icon class="mdi mdi-fullscreen text-2xl leading-7 max-h-[20px] text-white"></mat-icon>
          </button>
          <button *ngIf="!displayFooter" (click)="onFullscreen(false)" class="flex justify-center items-center bg-transparent p-[2px]">
            <mat-icon class="mdi mdi-fullscreen-exit text-2xl leading-7 max-h-[20px] text-white"></mat-icon>
          </button>
          <button (click)="closeBaseModal()" class="flex justify-center items-center bg-transparent p-[2px]">
            <ion-icon name="close" class="text-2xl leading-7 max-h-[20px] text-white"></ion-icon>
          </button>
        </div>
      </div>

      <ng-content ></ng-content>
    </div>
  </ng-template>
</ion-modal>
